import { StorageRef, ChartingItemType, ChartingSpecialChecklistItems, ChartingSelectType, ChartingRequiredCondition } from '@caresend/types';
import { isInEnum, getUTCTimezoneDate, capitalize } from '@caresend/utils';
import { storeToRefs } from 'pinia';
import { defineComponent, computed, ref } from 'vue';
import Warning from '../../../assets/icons/warning.svg.js';
import __vue_component__ from '../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$2 from '../../inputs/DatePicker/DatePicker.vue.js';
import __vue_component__$3 from '../../inputs/FilePicker/FilePicker.vue.js';
import __vue_component__$4 from '../../inputs/SelectComponent.vue.js';
import __vue_component__$5 from '../../inputs/TextBoxPicker/TextBoxPicker.vue.js';
import __vue_component__$6 from '../../inputs/TextInput/TextInput.vue.js';
import __vue_component__$1 from './ChartingChecklistItemCard.vue.js';
import { usePortalStore } from '../portal/store/portal/index.js';
import { getChartingItemHighlightReferenceByIndexArray } from '../portal/store/portal/helpers/charting.js';
import { setProcedureChartingItems } from '../portal/store/portal/set/procedure.js';
import { formatPatientDataOnTube } from '../TubeLabelingExample/helpers.js';
import __vue_component__$7 from '../TubeLabelingExample/TubeLabelingExample.vue.js';
import TransitionExpand from '../../transitions/TransitionExpand/TransitionExpand.js';
import '../portal/store/portal/sessionStore.js';
import 'file-saver';
import '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/encryption/model.js';
import 'js-sha256';
import { getStore } from '../../../store/helpers/initStore.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../portal/store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../database/firebaseConfig/init.js';
import '../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'immutability-helper';
import '../../../router/routes/dev/model.js';
import '../../../router/routes/dev/routes.js';
import '../../../router/routes/dashboard/model.js';
import '../../../router/routes/pro/model.js';
import '../../../router/routes/visitsPage/model.js';
import '../../../router/routes/orderFlow/model.js';
import '../../../router/routes/orderFlow/privateHelpers.js';
import '../../../router/routes/orderFlow/routes.js';
import '../../../router/routes/schedulingFlow/model.js';
import '../../../router/routes/schedulingFlow/routes.js';
import '../../../router/routes/chartingFlow/model.js';
import '../../../router/routes/chartingFlow/routes.js';
import '../../../router/routes/portal/portalRoutes.js';
import '../../../router/routes/portal/model.js';
import '../../../router/routes/visitsPage/routes.js';
import '../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../store/pinia/draftWaypoints/index.js';
import '../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../store/modules/chartingFlow/model.js';
import '../../../store/modules/office/index.js';
import '../VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../store/modules/office/model.js';
import '../../../store/modules/orderFlow/index.js';
import '../../../store/modules/procedures/model.js';
import '../../../store/modules/schedulingFlow/index.js';
import '../../../store/modules/schedulingFlow/model.js';

// Do this for backwards compatibility - the id may not be present in old charting items
const CHARTING_HOSPITAL_TITLE = 'Check below ONLY if blood is collected for a hospital inpatient. Leave blank if unknown.';
var script = defineComponent({
    name: 'ChartingItemCard',
    components: {
        BasicCard: __vue_component__,
        ChartingChecklistItemCard: __vue_component__$1,
        DatePicker: __vue_component__$2,
        FilePicker: __vue_component__$3,
        SelectComponent: __vue_component__$4,
        TextBoxPicker: __vue_component__$5,
        TextInput: __vue_component__$6,
        TransitionExpand,
        TubeLabelingExample: __vue_component__$7,
        Warning,
    },
    props: {
        procedureID: {
            type: String,
            required: true,
        },
        /**
         * An array of indices to support charting items nested in groups.
         * Example: [1, 2] - Root ChartingItem of index 1, nested non-group
         * ChartingItem of index 2.
         */
        indexArray: {
            type: Array,
            required: true,
        },
        /**
         * If true, there is a results value that is filled in. in this case,
         * some special requirements may apply based off the item's requirement
         * condition value. These could come into play when showing the asterisk
         */
        chartingNotesIsFilled: {
            type: Boolean,
            default: undefined,
        },
        /**
         * If true, display any pending items
         */
        highlight: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        var _a, _b;
        const storagePath = StorageRef.CHARTING;
        const portalStore = usePortalStore();
        const { chartingHighlightItems } = storeToRefs(portalStore);
        const item = computed(() => portalStore.procedures.getters.chartingItemByIndexArray(props.procedureID, props.indexArray));
        const isItemHighlighted = computed(() => {
            var _a;
            return !!((_a = getChartingItemHighlightReferenceByIndexArray(chartingHighlightItems.value, props.indexArray)) === null || _a === void 0 ? void 0 : _a.highlight);
        });
        const isChecklist = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.CHECKLIST; });
        const isDate = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.DATE; });
        const isFiles = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.FILES; });
        const isGroup = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.GROUP; });
        const isNotes = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.NOTES; });
        const isResults = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.RESULTS; });
        const isSelect = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.SELECT; });
        const isText = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.TEXT; });
        const isTubeLabeling = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.id) === ChartingSpecialChecklistItems.CHARTING_TUBE_LABELING_CHECK; });
        const isHospitalDraw = computed(() => {
            var _a, _b;
            return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.id) === ChartingSpecialChecklistItems.CHARTING_HOSPITAL_DRAW_CHECK
                || ((_b = item.value) === null || _b === void 0 ? void 0 : _b.title) === CHARTING_HOSPITAL_TITLE;
        });
        const isValid = computed(() => { var _a; return !!((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) && isInEnum(item.value.type, ChartingItemType); });
        const textBoxPickerItems = computed(() => { var _a, _b, _c; return (_c = (_b = (_a = item.value) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.map((option) => ({ label: option, value: option }))) !== null && _c !== void 0 ? _c : []; });
        const textBoxPickerHorizontal = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.selectType) === ChartingSelectType.TEXT_BOX_PICKER_HORIZONTAL; });
        const isRequired = computed(() => {
            var _a, _b, _c;
            if (((_a = item.value) === null || _a === void 0 ? void 0 : _a.requiredCondition) === ChartingRequiredCondition.TRUE)
                return true;
            if (props.chartingNotesIsFilled === undefined)
                return false;
            return (((_b = item.value) === null || _b === void 0 ? void 0 : _b.requiredCondition) === ChartingRequiredCondition.CHART_IF_TRUE
                && props.chartingNotesIsFilled) || (((_c = item.value) === null || _c === void 0 ? void 0 : _c.requiredCondition) === ChartingRequiredCondition.CHART_IF_FALSE
                && !props.chartingNotesIsFilled);
        });
        const setChartingItem = (newItem) => {
            const params = {
                procedureID: props.procedureID,
                newPartialChartingItem: newItem,
                chartingItemIndexArray: props.indexArray,
            };
            setProcedureChartingItems(params, false);
        };
        const setChartingPhotos = async (encryptedFiles) => {
            if (!encryptedFiles || !item.value)
                return;
            const newItem = {
                files: encryptedFiles,
            };
            setChartingItem(newItem);
        };
        const currentText = ref((_b = (_a = item.value) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : null);
        /**
         * Set the current text value in the component - NOT save on the charting item
         */
        const setText = (text) => { currentText.value = text; };
        /**
         * Save the current text value to the charting item.
         */
        const saveText = async () => {
            if (!item.value || currentText.value === null)
                return;
            const newItem = {
                text: currentText.value,
            };
            setChartingItem(newItem);
        };
        const setSelection = async (selection) => {
            if (!item.value)
                return;
            const newItem = {
                selection,
            };
            setChartingItem(newItem);
        };
        /**
         * There was a bug with using the input value, so ensure that you empty-out the whole date object
         * when the date is cleared by the user using this v-model.
         */
        const dateValue = computed({
            get: () => { var _a, _b, _c; return (_c = (_b = (_a = item.value) === null || _a === void 0 ? void 0 : _a.date) === null || _b === void 0 ? void 0 : _b.timestamp) !== null && _c !== void 0 ? _c : null; },
            set: (timestamp) => {
                const newItem = {
                    date: timestamp ? getUTCTimezoneDate(timestamp) : undefined,
                };
                setChartingItem(newItem);
            },
        });
        const patientDataForTubeLabeling = computed(() => {
            if (!isTubeLabeling.value)
                return;
            const store = getStore();
            const booking = store.getters['procedures/getProcedureBooking'](props.procedureID);
            if (!booking)
                return;
            const patient = store.getters['users/getUserByID'](booking.patientID);
            return formatPatientDataOnTube(patient);
        });
        const resultsPlaceholder = computed(() => { var _a, _b, _c; return (_b = (_a = item.value) === null || _a === void 0 ? void 0 : _a.resultsPlaceholder) !== null && _b !== void 0 ? _b : (_c = item.value) === null || _c === void 0 ? void 0 : _c.title; });
        const highlightMessage = computed(() => { var _a, _b; return (_b = (_a = item.value) === null || _a === void 0 ? void 0 : _a.highlightMessage) !== null && _b !== void 0 ? _b : 'This field is required'; });
        return {
            capitalize,
            dateValue,
            highlightMessage,
            isChecklist,
            isDate,
            isFiles,
            isGroup,
            isHospitalDraw,
            isNotes,
            isResults,
            isSelect,
            isText,
            isTubeLabeling,
            isRequired,
            isValid,
            item,
            patientDataForTubeLabeling,
            resultsPlaceholder,
            saveText,
            setChartingPhotos,
            setSelection,
            setText,
            storagePath,
            isItemHighlighted,
            textBoxPickerItems,
            textBoxPickerHorizontal,
        };
    },
});

export { script as default };
